import {fetchData} from '../../utils';
import {getJsOnceToken} from '../../views/main/components/operateActivity/initParisFactory.js';
import md5 from 'js-md5';
import {Toast} from '@baidu/onemap-design';

let isAwarding = false; // 是否正在开奖中，防止重复开奖
let isFirstTask = true; // 是否是第一次开始计数任务
let taskTimer = Date.now();
export default {
    namespaced: true,

    state: {
        taskNumObj: {
            num: 0,
            total: 0,
            award_flag: 0
        },
        // 打卡列表
        checkInList: {
            history: []
        },
        isOperateFailed: false, // 是否开奖失败
        tokenParam: {
            cuid: '',
            token: '',
            timestamp: Date.now(),
            os: '',
            mb: '',
            sv: ''
        },
        isAward: false, // 是否已领取奖励
        awardObj: {}, // 开奖对象信息
        isClickTasked: false // 是否已点击任务按钮
    },

    getters: {
        isLogin: state => state.isLogin,
        taskNumObj: state => {
            return state.taskNumObj;
        },
        checkInList: state => {
            return state.checkInList;
        },
        isOperateFailed: state => {
            return state.isOperateFailed;
        },
        isAward: state => {
            return state.isAward;
        },
        awardObj: state => {
            return state.awardObj;
        },
        isClickTasked: state => {
            return state.isClickTasked;
        }
    },

    mutations: {
        setIsLogin(state, isLogin) {
            state.isLogin = isLogin;
        },
        setTaskNumObj(state, params) {
            state.taskNumObj = params;
        },
        setCheckInList(state, params) {
            state.checkInList = params;
        },
        setTaskTokenParam(state, param) {
            state.tokenParam = param;
        },
        setOperateFailed(state, isOperateFailed) {
            state.isOperateFailed = isOperateFailed;
        },
        setIsAward(state, isAward) {
            state.isAward = isAward;
        },
        setAwardObj(state, awardObj) {
            state.awardObj = awardObj;
        },
        // 完成任务后是否点击了完成任务按钮
        setIsClickTasked(state, isClickTasked) {
            state.isClickTasked = isClickTasked;
        }
    },

    actions: {
        // 计数接口
        addTask({state, commit, dispatch, rootState}) {
            const {finish = 0} = state.checkInList;
            // 限制1s 内只能请求一次接口，防止接口频繁请求，第一次请求时不限制
            if (((Date.now() - taskTimer < 1000) && !isFirstTask) || isAwarding || finish) {
                return;
            }

            taskTimer = Date.now();
            isFirstTask = false;

            return getJsOnceToken().then(tokenObj => {
                dispatch('getTaskTokenParam', {tokenObj, hasTaskParam: true, salt: 'WVCw0MOuFGHBxXl'});

                const {requestTime = ''} = rootState.dataList;
                const params = {
                    incr_id: requestTime,
                    ...state.tokenParam
                };
                const url = '/feed-server/activity/task/incr';

                return fetchData(url, {
                    method: 'post',
                    params
                }).then(res => {
                    if (res.errno === 0) {
                        commit('setOperateFailed', false);
                        if (state.isClickTasked) {
                            commit('setIsClickTasked', false);
                        }
                        commit('setTaskNumObj', res.data);
                        // 如果已经开奖，并且完成数量小于总数，重新更新开奖状态
                        if (state.isAward && res.data.num < res.data.total) {
                            commit('setIsAward', false);
                        }
                        if (res.data.award_flag) {
                            dispatch('getAward', params);
                        }
                    }
                }).catch(err => {
                    console.error(err, 'error');
                });
            });
        },

        // 打卡接口
        getCheckIn({state, commit, rootState, dispatch}, isAward = false) {
            return getJsOnceToken().then(tokenObj => {
                const url = '/feed-server/activity/task';

                dispatch('getTaskTokenParam', {tokenObj, salt: 'tzNW8faDDGTxOgl'});

                const params = {
                    ...state.tokenParam
                };

                return fetchData(url, {
                    method: 'post',
                    params
                }).then(res => {
                    const {
                        errno = -1,
                        data = {}
                    } = res;
                    if (errno === 0 && data.history && (data.history.length > 0)) {
                        commit('setCheckInList', data);
                        // 更新开奖状态
                        commit('setIsAward', isAward);
                    }
                    else {
                        showErrorToast();
                    }
                    if (isAwarding) {
                        isAwarding = false;
                    }
                }).catch(err => {
                    if (isAwarding) {
                        isAwarding = false;
                    }
                    showErrorToast();
                    console.error(err, 'get task error');
                });
            });
        },
        // 开奖接口
        getAward({state, commit, rootState, dispatch}) {
            if (isAwarding) {
                return;
            }
            isAwarding = true;
            return getJsOnceToken().then(tokenObj => {
                dispatch('getTaskTokenParam', {tokenObj, hasTaskParam: true, salt: 'Y4dybcFbGAbLLqF'});

                const {cityId: city_id = ''} = rootState;
                const url = '/feed-server/activity/lottery';
                const params = {
                    city_id,
                    ...state.tokenParam
                };

                return fetchData(url, {
                    method: 'post',
                    params
                }).then(res => {
                    const {
                        errno,
                        data
                    } = res || {errno: -1, data: {}};
                    if (errno !== 0) {
                        showErrorToast();
                        commit('setOperateFailed', true);
                    }
                    else {
                        commit('setAwardObj', data);
                    }
                    const isAward = errno === 0;
                    dispatch('getCheckIn', isAward);
                }).catch(err => {
                    isAwarding = false;
                    console.error(err, 'award error');
                });
            });
        },

        // 处理token等公共参数
        getTaskTokenParam({state, rootState, commit}, {tokenObj = {}, hasTaskParam = false, salt = ''}) {
            const {task_id = 0, task_type = 0} = state.checkInList;
            const {cuid = '', os = '', mb = '', sv = ''} = rootState.url.urlParams;
            const t = Math.floor(Date.now() / 1000);
            let token = md5(
                `cuid=${cuid}&timestamp=${t}${salt}`
            );

            const tokenParam = {
                cuid,
                timestamp: t,
                os,
                mb,
                sv,
                token,
                ...tokenObj
            };

            if (hasTaskParam && (task_id || task_type)) {
                token = md5(
                    `cuid=${cuid}&task_id=${task_id}&task_type=${task_type}&timestamp=${t}${salt}`
                );
                tokenParam.task_id = task_id;
                tokenParam.task_type = task_type;
                tokenParam.token = token;
            }

            commit('setTaskTokenParam', tokenParam);
        }
    }
};
function showErrorToast() {
    Toast({
        message: '活动火爆，请您稍后重试，搜索【领红包】参与活动~',
        position: 'center',
        duration: 2000
    });
}